import React from 'react';

const Section = ({ children, id, className = '', background = 'white' }) => {
    const bgColors = {
        white: 'bg-white',
        slate: 'bg-slate-50',
        dark: 'bg-slate-900 text-white',
    };

    return (
        <section id={id} className={`py-16 md:py-24 ${bgColors[background]} ${className}`}>
            <div className="container mx-auto container-padding">
                {children}
            </div>
        </section>
    );
};

export default Section;
